/**
 *
 * UnbindingAccessCardDialog constants
 *
 */

export const SUBMIT_UNBINDING_ACCESS_CARD_DIALOG = 'claris-vnext/RequestsPage/UnbindingAccessCardDialog/SUBMIT_UNBINDING_ACCESS_CARD_DIALOG';
export const CHANGE_LOADING_STATE = 'claris-vnext/RequestsPage/UnbindingAccessCardDialog/CHANGE_LOADING_STATE';
export const CHANGE_SNACKBAR_STATE = 'claris-vnext/RequestsPage/UnbindingAccessCardDialog/CHANGE_SNACKBAR_STATE';
